import { FilterQueryType } from "cloud-core/filters/FilterSet";
import { AnalyticsStateView } from "../../../store/analytics/Analytics";
import { StringFilter } from "../../../views/viz/components/Filtering/StringFilter";
import { Entity } from "../Entity";
import { EntityFilter } from "./EntityFilter";

export class StringEntityFilter extends EntityFilter {
    type: FilterQueryType = "text";
    propertyGetter: (e: Entity) => string;

    constructor(displayName: string, filterRef: string, propertyGetter: (e: Entity) => string) {
        super(displayName, filterRef);
        this.propertyGetter = propertyGetter;
    }

    predicate(entities: Entity[], parameter: string): Entity[] {
        return entities.filter((e) => this.propertyGetter(e).includes(parameter));
    }

    createComponent(filterId: string, view: AnalyticsStateView, options?: unknown): JSX.Element {
        return <StringFilter viewId={view.viewId} filterId={filterId} placeholder={this.displayName} />;
    }

    createParameterObject(parameter: string): unknown {
        return { value: parameter };
    }

    parseParameterObject(parameterObject: unknown): string {
        return (parameterObject as { value: string }).value;
    }
}

export function StringPropertyGetter(key: string) {
    return (e: Entity) => {
        const property = e.properties[key];
        return property.display().toLowerCase();
    };
}
